<template>
  <section
    class="settings-section"
    :aria-labelledby="id"
  >
    <h2
      :id="id"
      class="text-h2 text-textDarkest mb-4"
    >
      {{ title }}
    </h2>
    <p class="section-description mb-4">
      <slot name="description" />
    </p>
    <slot />
  </section>
</template>

<script setup>
defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
});
</script>

<style scoped lang="less">
.settings-section {
  width: 100%;
}

.section-description {
  max-width: 100%;
  font-size: 16px;
  font-weight: 500 !important;
  line-height: 1.45;
  color: @text-dark;

  :deep(a) {
    color: @text-brand;
    font-weight: 500 !important;
    text-decoration: underline;

    &:hover,
    &:focus-visible {
      opacity: 0.8;
    }
  }
}
</style>
